module.exports = __webpack_public_path__ + "img/嘘.b155d827.png";